import { FC, useState } from 'react'
import { SiteModel } from '../../../core/_models'
type Props = {
  site: SiteModel
}
const SiteElectricalCell: FC<Props> = ({ site }) => {

  var formattedDate = '';

  if (site.constructionWorksContractedCompletionDate != null || site.constructionWorksContractedCompletionDate != undefined) {
    formattedDate = site.constructionWorksContractedCompletionDate === '0001-01-01T00:00:00' ? '' : new Date(site.constructionWorksContractedCompletionDate).toLocaleDateString('tr-TR');
  }

  return (
    <div className='d-flex align-items-center'>
      {formattedDate}
    </div>
  )
}




export { SiteElectricalCell }
